import Preferences from "action/Preferences";
import { observable } from "mobx";

import User from "../model/account/User";

export enum LoginStatus {
  LOGIN_REQUEST = "LOGIN_REQUEST",
  LOGIN_SUCCESS = "LOGIN_SUCCESS",
  LOGIN_FAILURE = "LOGIN_FAILURE",
}

class SessionStore {
  public readonly TOKEN_KEY = "X-Auth-Token";
  public readonly PATH_KEY = "X-Auth-Path";

  private _user: User;

  @observable
  private _loginStatus: LoginStatus = LoginStatus.LOGIN_REQUEST;

  private _ownerOidList: string[];

  public get loginStatus(): LoginStatus {
    return this._loginStatus;
  }

  public set loginStatus(value: LoginStatus) {
    this._loginStatus = value;
  }

  private _token: string = null;

  public get token(): string {
    return this._token;
  }

  public set token(value: string) {
    this._token = value;
  }

  private _type: string = "Anonymous";

  public get type(): string {
    return this._type;
  }

  public set type(value: string) {
    this._type = value;
  }

  public updateToken(token: string, path: string) {
    localStorage.setItem(this.TOKEN_KEY, token);
    localStorage.setItem(this.PATH_KEY, path);
    this._token = token;
  }

  public removeToken() {
    Preferences.clear();
    this._token = undefined;
    location.reload();
  }

  public getToken() {
    return localStorage.getItem(this.TOKEN_KEY);
  }

  public getPath() {
    const path = localStorage.getItem(this.PATH_KEY);
    return path ? path : undefined;
  }

  public get ownerOidList(): string[] {
    return this._ownerOidList || [];
  }

  public set ownerOidList(value: string[]) {
    this._ownerOidList = value;
  }

  public set user(user: User) {
    this._user = user;
  }

  public get user() {
    return this._user;
  }
}

const sessionStore = new SessionStore();
export default sessionStore;
